import React from "react";
import Style from "./Support.module.css";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import SupportListTabel from "./SupportListTabel";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from "@fortawesome/free-solid-svg-icons";

function Poshtibani() {
  let history = useHistory();

  return (
    <section className={Style.pageHolder}>
      <BurgerMenuTitle title="پشتیبانی" />
      <div className={Style.imageHolder}><img src="/Assets/Images/support/supportSvg.svg" alt="" /></div>
      <div className={Style.SupportCallHolder}><p>تماس با پشتیبانی:</p><p><a href="tel:01144400765">01144400765 <FontAwesomeIcon icon={faPhone}/></a> --- <a href="tel:09112524435">09112524435 <FontAwesomeIcon icon={faPhone}/></a></p></div>
      <button className={Style.newChatBtn} onClick={()=>history.push("/newmessage")}>ایجاد پیام جدید +</button>
      <SupportListTabel/>
    </section>
  );
}
export default Poshtibani;
